export default "__VITE_ASSET__BBrZXLrb__"